import React from "react";
// Link removed as we use window.location
import AnalyticsImg from "../../assets/img/features/platform-scout-preview.png";
import Logo from "../../assets/img/logo/comparedly-logo.png";
import "../../assets/css/Blog.css"; // Ensure styles are loaded

const InListCTA = () => {
    return (
        <div className="blog-card in-list-cta">
            <div className="in-list-cta-content">
                <div className="in-list-brand">
                    <img src={Logo} alt="Comparedly" className="in-list-logo" />
                    <span className="in-list-brand-name">Comparedly</span>
                </div>

                <h3 className="in-list-title">
                    Unlock Competitive Insights for Business Growth
                </h3>

                <div className="in-list-image-container">
                    <img src={AnalyticsImg} alt="Dashboard Preview" className="in-list-dashboard-img" />
                </div>

                <button
                    className="btn-primary cta-action-btn"
                    onClick={() => window.location.href = `${process.env.REACT_APP_URL}/auth/register`}
                    style={{ width: 'auto', display: 'inline-block' }} /* Inline override to maintain reduced width preference if cta-action-btn is wide */
                >
                    Start Your Free Trial
                </button>
            </div>
        </div>
    );
};

export default InListCTA;
